import { UploadETicketsSectionProps } from 'src/modals/PurchaseWizard/PurchaseTicketsFlow/components/UploadETicketsSection';
import { UploadETicketsSectionV2 } from 'src/modals/PurchaseWizard/PurchaseTicketsFlowV2/components/UploadETicketsSectionV2';

type UploadETicketsVersionSelectorProps = UploadETicketsSectionProps;

export const UploadETicketsSectionSelector = ({
  ticketType,
  ticketGroupIndex,
  onCancel,
}: UploadETicketsVersionSelectorProps) => {
  return (
    <UploadETicketsSectionV2
      ticketGroupIndex={ticketGroupIndex}
      onCancel={onCancel}
      ticketType={ticketType}
    />
  );
};
